import React from "react";
import ReactDOM from "react-dom/client";

import "@/styles/style.css";
import "@/i18n";

import { authConfig } from "@/auth";
import { queryClient } from "@/client";
import config from "@/config";
import ApiProvider from "@/contexts/ApiClientContext";
import MobileRestrictionPage from "@/pages/MobileRestriction";
import { router } from "@/router";
import { LogtoProvider } from "@logto/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { PostHogProvider } from "posthog-js/react";
// eslint-disable-next-line
// @ts-ignore
import { Helmet } from "react-helmet";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";

import useMobileViewport from "@/hooks/useMobileViewport";

import "sentry.config.ts";

const App = () => {
  const isMobile = useMobileViewport();

  const isProd = config.CUSTOM_ENVIRONMENT === "production";

  return (
    <LogtoProvider config={authConfig}>
      <ApiProvider>
        <QueryClientProvider client={queryClient}>
          <PostHogProvider apiKey={config.POSTHOG_KEY} options={{ api_host: config.POSTHOG_HOST }}>
            {!isProd && (
              <Helmet>
                <meta name="robots" content="noindex,nofollow" />
              </Helmet>
            )}
            <Toaster position="bottom-right" containerStyle={{ zIndex: 99 }} />
            {isMobile ? <MobileRestrictionPage /> : <RouterProvider router={router} />}
          </PostHogProvider>
        </QueryClientProvider>
      </ApiProvider>
    </LogtoProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
